import axios from 'axios';
import { newBackendBaseUrl } from '../config';
import history from '../history';

// NAS-HA-6110 — Home Audio CS console calls. Same host/header pattern the complaint
// screens use: newBackendBaseUrl + /connect-complaint/v1/... with x-access-token.
const INSTALLATION_PATH = '/connect-complaint/v1/installation';

const authConfig = () => ({ headers: { 'x-access-token': localStorage.getItem('token') } });

const unwrap = (res) => {
    if (res.data && res.data.success) {
        return { success: true, data: res.data.data, message: res.data.message };
    }
    return { success: false, error: (res.data && res.data.message) || 'Something went wrong' };
};

const toFailure = (e) => {
    if (e && e.response && e.response.status === 401) {
        localStorage.removeItem('token');
        history.push('/');
        return { success: false, error: 'Session expired. Please log in again.' };
    }
    const message =
        (e && e.response && e.response.data && e.response.data.errors && e.response.data.errors.message) ||
        (e && e.message) ||
        'Network error';
    return { success: false, error: message };
};

const postInstallation = async (path, body) => {
    try {
        const res = await axios.post(newBackendBaseUrl + INSTALLATION_PATH + path, body, authConfig());
        return unwrap(res);
    } catch (e) {
        return toFailure(e);
    }
};

export const fetchInstallationList = (body) => postInstallation('/list', body);

export const fetchInstallationDetail = (requestId) => postInstallation('/detail', { request_id: Number(requestId) });

export const submitInstallationAction = (body) => postInstallation('/action', body);

// One action over a multi-selected set; the reply reports moved + skipped, not all-or-nothing.
export const submitInstallationBulkAction = (body) => postInstallation('/bulk-action', body);

// Home Audio COMPLAINTS: the three service-partner actions. complaint_id is the encrypted id
// the complaint detail API returns, like every other complaint action.
export const actionHomeAudioComplaint = (body) => postInstallation('/complaint/action', body);

// §5.3 source correction and §7.3 Verify Payment Now — operator tools, not bucket moves.
export const updateInstallationSource = (body) => postInstallation('/source', body);

export const verifyInstallationPayment = (requestId) => postInstallation('/payment/verify', { request_id: Number(requestId) });

// Manual CSV source. The same file is posted twice: once to preview (confirm=false), once to
// import (confirm=true). axios sets the multipart boundary itself when given a FormData.
export const fetchInstallationCsvTemplate = () => postInstallation('/csv-template', {});

export const importInstallationCsv = (formData) => postInstallation('/csv-import', formData);

// Admin only on the server; the UI gate is UX, the 403 is the control.
export const exportInstallationRequests = (body) => postInstallation('/export', body);

// Shared CS closure-reason master, fetched once when the close form is first opened.
export const fetchInstallationClosureReasons = async () => {
    try {
        const res = await axios.get(`${newBackendBaseUrl}/connect-complaint/v1/ticket-closure-reason/list?type=CS`, authConfig());
        return unwrap(res);
    } catch (e) {
        return toFailure(e);
    }
};
